<template>
  <div style="position: relative">
    <Navbar type="bg-transparent-sticky" />
      <div class="hero-container-thin">
        <div class="hero-opacity" />
        <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
      </div>
    <Breadcrumb />

    <div class="container-xl mb-5" style="position: relative !important;">
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay d-flex justify-content-center mb-3">
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <div class="text-container">
        <div class="title-area">
          <div class="d-flex">
            <h1 class="page-title h2">
              <span id="set-information" class="">{{ screentexts[14] ? screentexts[14].element_text : 'Add members to: '
                }}
                {{ group.group_name }}
                <!-- <PopupBubble
                  v-if="screentexts[14] && screentexts[14].element_bubbletext != '' && screentexts[14].element_bubbletext !== null"
                  element_id="set-information"
                  screenelement_id="14"
                  :screen_id="screen_id"
                  :bubbletext="screentexts[14]?screentexts[14].element_bubbletext:''"
                /> -->
              </span>
            </h1>
          </div>
        </div>
        <div v-show="newgroupmembers.length == 0" class="mb-3">
          <span>{{ screentexts[18] ? screentexts[18].element_text : '' }}</span>
          <!-- <PopupBubble
                v-if="screentexts[18] && screentexts[18].element_bubbletext != '' && screentexts[18].element_bubbletext !== null"
                :screen_id="screen_id"
                screenelement_id="18"
                :bubbletext="screentexts[18]?screentexts[18].element_bubbletext:''"
              /> -->
        </div>

        <h3 class="mb-4">
          <span>{{ screentexts[15] ? screentexts[15].element_text : 'Group members' }}</span>
        </h3>

        <div>
          <div>
            <div class="btn-group mb-4" role="group" aria-label="Toggle Content">
              <b-button :variant="activeContent === 'addMember' ? 'primary' : 'secondary'"
                @click="activeContent = 'addMember'" class="mr-3">
                {{ screentexts[22] ? screentexts[22].element_text : '' }}
              </b-button>

              <!-- <b-button :variant="activeContent === 'uploadMembers' ? 'primary' : 'secondary'"
                @click="activeContent = 'uploadMembers'">
                <span class="d-inline d-md-none">Upload group members Excel</span>
                <span class="d-none d-md-inline">{{ screentexts[21] ? screentexts[21].element_text : '' }}</span>
              </b-button> -->

              <b-button :variant="activeContent === 'pasteEmails' ? 'primary' : 'secondary'"
                @click="activeContent = 'pasteEmails'">
                <span class="d-inline d-md-none">Enter email addresses</span>
                <span class="d-none d-md-inline">Enter email addresses</span>
              </b-button>
            </div>
            <div v-if="activeContent === 'addMember'">
              <b-form class="bg-secondary add-member-container" novalidate @submit.stop.prevent>
                <b-form-group>
                  <label>{{ screentexts[167] ? screentexts[167].element_text : 'Form Type' }}</label>
                  <b-form-select v-model="groupmember_formoption_id" :options="formoptions" />
                </b-form-group>

                <b-form-group :state="groupmember_email_valid" v-show="groupmember_formoption_id == 1">
                  <label class="col-12 pl-0">{{ screentexts[164] ? screentexts[164].element_text : 'Email address'
                    }}</label>
                  <input @keydown.enter.prevent="addgroupmember"  v-model="groupmember_email" class="form-control col-12" :class="`${anon ? 'g-anon' : ''}`"
                    :state="groupmember_email_valid" type="text"
                    :placeholder="screentexts[170] ? screentexts[170].element_text : 'Email Address'" />
                  <div v-show="groupmember_email_valid == false" class="text-danger pt-2">
                    Invalid or duplicate email address
                  </div>
                  <span v-show="groupmember_email_valid != false">&nbsp;</span>
                </b-form-group>

                <b-form-group class="mb-0">
                  <div class="text-right">
                    <b-button class="mr-2" variant="danger" @click.prevent="activeContent=null">
                      {{ screentexts[168] ? screentexts[168].element_text : 'Cancel'}}
                    </b-button>
                    <b-button variant="primary" @click.prevent="addgroupmember">
                      {{ screentexts[175] ? screentexts[175].element_text : 'Add'}}
                    </b-button>
                  </div>
                </b-form-group>
              </b-form>
            </div>

            <div v-if="activeContent === 'uploadMembers'">
              <b-alert :show="message != '' && newgroupmembers.length != 0" dismissable variant="danger"
                v-html="message" />
              <div class="bg-secondary add-member-container text-md">
                <div v-show="uploading == false">
                  <p><span>{{ screentexts[23] ? screentexts[23].element_text : '' }}</span></p>
                  <ul>
                    <li><span>{{ screentexts[24] ? screentexts[24].element_text : '' }}</span></li>
                    <li><span>{{ screentexts[27] ? screentexts[27].element_text : '' }}</span></li>
                  </ul>
                </div>
                <div class="text-center">
                  <b-spinner v-show="uploading" label="Uploading" style="width: 4rem; height: 4rem;" type="grow"
                    variant="primary" />
                </div>
                <p v-show="uploading == false">
                  <a class="button" href="/GDQ_Group_Members_Import_Template_v2.xls" target="_blank"
                    download="/GDQ_Group_Members_Import_Template_v2.xls">
                    <span>{{ screentexts[28] ? screentexts[28].element_text : 'Click here to download the Excel template.' }}</span>
                  </a>
                </p>
                <b-form-group v-show="uploading == false">
                  <b-form-file ref="file_input" v-model="file_input" accept="application/vnd.ms-excel"
                    :placeholder="screentexts[29] ? screentexts[29].element_text : 'Choose a file or drop it here.'"
                    drop-placeholder="Drop file here..." />
                  <span class="col-4 float-right" />
                </b-form-group>
              </div>
            </div>

            <div v-if="activeContent === 'pasteEmails'">
              <div class="bg-secondary add-member-container text-md">
                <div class="text-center">
                  <b-spinner v-show="uploading" label="Adding email addresses..." style="width: 4rem; height: 4rem;" type="grow"
                    variant="primary" />
                </div>
                <div v-show="uploading == false">
                  <p><span>Please enter or paste group member email addresses below, one email address on each line. All group members created this way will get the form type &quot;Online - Email address required&quot;</span></p>
                  <b-form-textarea
                    id="textarea"
                    v-model="pastedemails"
                    placeholder="Paste email addresses here..."
                    rows="10"
                  ></b-form-textarea>
                  <b-button class="mt-4" variant="primary" @click.prevent="addemailaddresses">
                    {{ 'Add these email addresses as new group members'}}
                  </b-button>
                </div>
              </div>
              <b-alert :show="emailerrors != ''" class="mt-3" variant="danger">
                <div v-html="emailerrors"></div>
              </b-alert>
            </div>
          </div>
        </div>

        <div v-show="groupmembers_db.length > 0" class="mb-5">
          <b-table :class="'actions-table save-cancel mt-5'" :items="groupmembers_db" :fields="groupmember_fields"
            :tbody-tr-class="rowClass">

            <template v-slot:cell(actions)="data">
              <div class="d-flex justify-content-end">
                <div v-if="data.item.editable">
                  <b-button variant="danger" class="btn-tiny mr-1"
                    @click.prevent="cancelEdit(data.item.id)">Cancel</b-button>
                  <b-button variant="primary" class="btn-tiny" @click.prevent="saveEdit(data.item.id)">Save</b-button>
                </div>
                <b-dropdown right class="ml-2">
                  <template #button-content>
                    <i class="fa-solid fa-ellipsis"></i>
                  </template>
                  <b-dropdown-item @click.prevent="editGroupMember(data.item.id)">Edit</b-dropdown-item>
                  <b-dropdown-item @click.prevent="deletegroupmember(data.item.id)">Delete</b-dropdown-item>
                </b-dropdown>
              </div>
            </template>

            <template v-slot:cell(newgroupmember_email)="data">
              <div class="position-relative">
                <div v-if="!data.item.editable" :class="{ 'g-anon': anon }">
                  {{ data.item.newgroupmember_email }}
                </div>
                <b-form-input
                  v-else
                  v-model="data.item.newgroupmember_email"
                  type="text"
                  :class="{'g-anon': anon, 'text-danger': data.item.groupmember_email_valid == false}"
                />
                <i
                  v-if="data.item.groupmember_email_valid == false && data.item.editable"
                  class="fa-solid inline-tooltip fa-circle-question tooltip-question tooltip-danger"
                  v-b-tooltip="'Invalid email address'"
                ></i>
              </div>
            </template>

            <template v-slot:cell(newgroupmember_formoption)="data">
              <div class="uneditable" v-if="!data.item.editable">{{
                getFormOptionText(data.item.newgroupmember_formoption_id) }}</div>
              <b-form-select v-else v-model="data.item.newgroupmember_formoption_id" :options="formoptions" />
            </template>

          </b-table>
        </div>

        <b-row>
          <div class="col-6">
            <b-link to="/create/group" class="float-left">
              <b-button variant="secondary">
                &lt; Back
              </b-button>
            </b-link>
          </div>
          <div class="col-6 pr-0">
            <b-button :disabled="newgroupmembers.length == 0" variant="primary" class="float-right"
              @click.prevent="survey_create">
              Next >
            </b-button>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
// import PopupBubble from './PopupBubble.vue'

export default {
  name: 'CreateGroupMembers',
  components: {
    Navbar,
    Breadcrumb
    // PopupBubble,
  },
  data () {
    return {
      loading: false,
      uploading: false,
      groupmember_fields: [
        { key: 'newgroupmember_email', label: 'Email', class: 'editable email-column' },
        // { key: 'newgroupmember_name', label: 'Name', tdClass: 'col-3 td-3' },
        //        { key: 'newgroupmember_mobile', label: 'Mobile phone number', tdClass: 'col-3 td-3' },
        { key: 'newgroupmember_formoption', label: 'Form type', class: 'editable select-column' },
        { key: 'newgroupmember_actions', label: '', tdClass: 'col-1' },
        { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
      ],
      groupmember_name: '',
      groupmember_name_valid: null,
      groupmember_email: '',
      groupmember_email_valid: null,
      groupmember_mobile: '',
      groupmember_mobile_valid: null,
      groupmember_formoption_id: 1,
      groupmember_language_id: null,
      group_id: this.$store.state.currentgroup_id,
      survey_id: this.$store.state.currentsurvey_id,
      file_input: null,
      newgroupmembers: new Array(),
      message: '',
      screen_id: 4,
      screentexts: [],
      languages: [],
      original_member_data: {},
      activeContent: null,
      pastedemails: null,
      emailerrors: ''
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    group: {
      get () {
        return this.$store.state.currentgroup
      }
    },
    formoptions: {
      get () {
        var items = this.$store.state.formoptions
        var formoptions = []
        for (var i = 0; i < items.length; i++) {
          var option = {
            value: items[i].id,
            text: items[i].formoption_name
          }
          formoptions.push(option)
        }
        return formoptions
      }
    },
    groupmembers_db: {
      get () {
        this.loading = true
        var currentgroupmembers = this.$store.state.currentgroupmembers
        var groupmembers_db = []
        for (var i = 0; i < currentgroupmembers.length; i++) {
          var currentgroupmember = currentgroupmembers[i]
          var formoptiontext = ''
          for (var j = 0; j < this.formoptions.length; j++) {
            if (this.formoptions[j].value == currentgroupmember.groupmember_formoption_id) {
              formoptiontext = this.formoptions[j].text
            }
          }
          var m = {
            id: currentgroupmember.id,
            newgroupmember_name: currentgroupmember.groupmember_name,
            newgroupmember_email: currentgroupmember.groupmember_email,
            newgroupmember_mobile: currentgroupmember.groupmember_mobile,
            newgroupmember_status_id: currentgroupmember.groupmember_status_id,
            newgroupmember_formoption: formoptiontext,
            newgroupmember_formoption_id: currentgroupmember.groupmember_formoption_id,
            newgroupmember_language_id: currentgroupmember.groupmember_language_id
          }
          groupmembers_db.push(m)
        }
        this.loading = false
        return groupmembers_db
      }
    }
  },
  watch: {
    file_input () {
      this.submitFile()
    },
    // ------------------------------------------------
    // We have fetched group members from the database
    // ------------------------------------------------
    groupmembers_db () {
      this.loading = true
      this.newgroupmembers = []
      if (this.groupmembers_db.length > 0) {
        for (var i = 0; i < this.groupmembers_db.length; i++) {
          this.groupmembers_db[i].editable = false
          this.newgroupmembers.push(this.groupmembers_db[i])
        }
      }
      this.loading = false
    }
  },
  async created () {
    await this.languages_get()
    await this.screentexts_get()
    await this.groupmembers_get()
  },
  methods: {
    async addemailaddresses () {
      this.uploading = true
      this.emailerrors = ''
      const emails = this.pastedemails.split('\n').map(email => email.trim()).filter(email => email)
      for (let i = 0; i < emails.length; i++) {
        const email = emails[i]
        if (this.parse_email(email)) {
          var code = Math.random().toString(36).replace(/[^a-z]+/g, '').substring(0, 2).toUpperCase()
          code = code + Math.round(Math.random() * (9999 - 1000) + 1000, 0)
          code = (this.groupmembers_db.length + i + 1).toString()
          var groupmember = {
            group_id: this.$store.state.currentgroup_id,
            groupmember_email: email,
            groupmember_mobile: '',
            groupmember_name: '',
            groupmember_code: code,
            groupmember_status_id: 1,
            groupmember_formoption_id: 1,
            groupmember_language_id: this.groupmember_language_id,
            editable: false
          }
          await this.$store.dispatch('groupmember_create', { groupmember: groupmember })
          // .then((res) => {
          //   await this.$store.dispatch('groupmembers_fetch', { group_id: this.$store.state.currentgroup_id })
          //   this.pastedemails = null;
          //   this.uploading = false;
          //   this.emailerrors = '';
          // })
        } else {
          this.emailerrors += email + '<br>\n'
        }
      }
      if (this.emailerrors != '') {
        this.emailerrors = 'Invalid email address(es):<br>\n' + this.emailerrors
      }
      this.pastedemails = null
      await this.$store.dispatch('groupmembers_fetch', { group_id: this.$store.state.currentgroup_id })
      this.uploading = false
    },
    rowClass (item, index) {
      return item.editable ? 'editable-row' : ''
    },
    editGroupMember (id) {
      for (let i = 0; i < this.groupmembers_db.length; i++) {
        if (this.groupmembers_db[i].id === id) {
          if (this.groupmembers_db[i].editable) {
            this.groupmembers_db[i].editable = false
          } else {
            // Cancel edit for all other rows
            this.groupmembers_db.forEach((member, index) => {
              if (index !== i) {
                this.cancelEdit(member.id)
              }
            })
            this.groupmembers_db[i].editable = true
            this.original_member_data[id] = JSON.parse(JSON.stringify(this.groupmembers_db[i]))
          }
        }
      }
    },

    cancelEdit (id) {
      const index = this.groupmembers_db.findIndex(member => member.id === id)
      if (index !== -1 && this.original_member_data[id]) {
        this.groupmembers_db[index].newgroupmember_email = this.original_member_data[id].newgroupmember_email
        this.groupmembers_db[index].newgroupmember_formoption_id = this.original_member_data[id].newgroupmember_formoption_id
        this.groupmembers_db[index].editable = false
        delete this.original_member_data[id]
      }
    },

    saveEdit (id) {
      const index = this.groupmembers_db.findIndex(member => member.id === id)
      if (index !== -1) {
        const member = this.groupmembers_db[index]
        if (this.validateEditedMember(member)) {
          member.editable = false
          delete this.original_member_data[id]
          var data = {
            id: member.id,
            groupmember_email: member.newgroupmember_email,
            groupmember_formoption_id: member.newgroupmember_formoption_id,
            groupmember_status_id: member.newgroupmember_status_id
          }
          this.$store.dispatch('groupmember_save', { groupmember: data }).then(() => {
            this.cleargroupmember()
            this.$store.dispatch('groupmembers_fetch', { group_id: this.$store.state.currentgroup_id })
          })
        } else {
          member.groupmember_email_valid = false
          const mail = member.newgroupmember_email
          member.newgroupmember_email = '' // force trigger reactivity
          member.newgroupmember_email = mail
        }
      }
    },

    validateEditedMember (member) {
      if (member.newgroupmember_formoption_id != 1) {
        member.groupmember_email_valid = null
        member.newgroupmember_email = ''
        return true
      } else {
        const isValid = this.parse_email(member.newgroupmember_email)
        return isValid
      }
    },

    getFormOptionText (id) {
      const option = this.formoptions.find(option => option.value === id)
      return option ? option.text : ''
    },

    async languages_get () {
      this.loading = true
      await this.$store.dispatch('languages_fetch')
        .then((resp) => {
          this.languages = resp.data.result.map(l => {
            return {
              value: l.id,
              text: l.language_name
            }
          })
          this.groupmember_language_id = this.$store.state.currentgroup.group_language_id
        })
      this.loading = false
    },
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(email.toLowerCase())
    },
    // Get screen texts
    screentexts_get: async function () {
      this.loading = true
      var screentexts = []
      var filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      await this.$store.dispatch('systemscreenelements_fetch', { filter: filter })
        .then((resp) => {
          var dbtexts = resp.data.result
          for (var i = 0; i < dbtexts.length; i++) {
            var screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
      this.loading = false
    },
    // ------------------
    // Upload Excel file
    // ------------------
    submitFile () {
      if (this.file_input != null && this.file_input.name != '') {
        this.uploading = true
        const fd = new FormData()
        fd.append('group_id', this.$store.state.currentgroup_id)
        fd.append('file', this.file_input)
        this.$store.dispatch('groupmembers_upload', fd)
          .then((result) => {
            if (result.data.errors && result.data.errors.length > 0) {
              for (var i = 0; i < result.data.errors.length; i++) {
                this.message = this.message + result.data.errors[i] + '<br>'
              }
            }
            this.$store.dispatch('groupmembers_fetch', { group_id: this.$store.state.currentgroup_id })
          })
          .then(() => {
            this.uploading = false
          })
      }
    },
    // ------------------------------------------
    // Dispatch saving group members to database
    // newgroupmembers is an array:
    // id
    // newgroupmember_name
    // newgroupmember_email
    // newgroupmember_mobile
    // newgroupmember_status_id
    // newgroupmember_formoption (for display)
    // newgroupmember_formoption_id
    // newgroupmember_language_id
    // ------------------------------------------
    cleargroupmember () {
      this.groupmember_name = ''
      this.groupmember_email = ''
      this.groupmember_mobile = ''
      this.groupmember_email_valid = null
    },
    validategroupmember (name, email, mobile, formoption_id) {
      var result = []
      var formok = true
      this.groupmember_name_valid = null
      this.groupmember_email_valid = null
      this.groupmember_mobile_valid = null
      // Online form
      if (formoption_id == 1) {
        if (email == '') {
          this.groupmember_email_valid = false
          formok = false
        }
        if (!this.parse_email(email)) {
          // eslint-disable-next-line
          // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) == false) {
          this.groupmember_email_valid = false
          formok = false
        }
        // ------------------------------
        // Check for duplicates - email
        // ------------------------------
        for (var j = 0; j < this.newgroupmembers.length; j++) {
          if (this.newgroupmembers[j].newgroupmember_email == email) {
            formok = false
            this.groupmember_email_valid = false
          }
        }
      }
      result['formok'] = formok
      return result
    },
    addgroupmember () {
      var validate =
        this.validategroupmember(
          this.groupmember_name,
          this.groupmember_email,
          this.groupmember_mobile,
          this.groupmember_formoption_id
        )
      // Here save IMMEDIATELY, POST HASTE
      if (validate['formok'] == true) {
        var code = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2).toUpperCase()
        code = code + Math.round(Math.random() * (9999 - 1000) + 1000, 0)
        code = (this.newgroupmembers.length + 1).toString()
        var groupmember = {
          group_id: this.$store.state.currentgroup_id,
          groupmember_email: this.groupmember_email,
          groupmember_mobile: this.groupmember_mobile,
          groupmember_name: this.groupmember_name,
          groupmember_code: code,
          groupmember_status_id: 1,
          groupmember_formoption_id: this.groupmember_formoption_id,
          groupmember_language_id: this.groupmember_language_id,
          editable: false
        }

        this.$store.dispatch('groupmember_create', { groupmember: groupmember })
          .then(() => {
            this.cleargroupmember()
            this.$store.dispatch('groupmembers_fetch', { group_id: this.$store.state.currentgroup_id })
          })
      }
    },
    deletegroupmember (id) {
      this.$store.dispatch('groupmember_delete', { 'id': id })
        .then(() => {
          this.$store.dispatch('groupmembers_fetch', { group_id: this.$store.state.currentgroup_id })
        })
    },
    groupmembers_get: async function () {
      if (this.$store.state.currentgroup_id && this.$store.state.currentgroup_id != 0) {
        this.loading = true
        await this.$store.dispatch('groupmembers_fetch', { group_id: this.$store.state.currentgroup_id })
        this.loading = false
      }
    },
    survey_create: async function () {
      this.loading = true
      if (this.$store.state.currentsurvey.id == 0) {
        var groupmembers = []
        for (var i = 0; i < this.newgroupmembers.length; i++) {
          var newmember = this.newgroupmembers[i]
          var groupmember = {
            id: newmember.id,
            groupmember_email: newmember.newgroupmember_email,
            groupmember_formoption_id: newmember.newgroupmember_formoption_id,
            groupmember_language_id: newmember.newgroupmember_language_id,
            groupsurveymember_formoption_id: newmember.newgroupmember_formoption_id,
            groupmember_mobile: newmember.newgroupmember_mobile,
            groupmember_name: newmember.newgroupmember_name,
            groupmember_status_id: newmember.newgroupmember_status_id,
            included_in_survey: 1
          }
          groupmembers.push(groupmember)
        }
        var data = {
          group_id: this.$store.state.currentgroup_id,
          groupmembers: groupmembers
        }
        await this.$store.dispatch('groupsurveymembers_create', data)
          .then((resp) => {
            this.group_id = resp.data.group_id
            this.survey_id = resp.data.survey_id
            this.$store.dispatch('group_setcurrent', { group_id: this.group_id })
              .then(() => {
                this.$store.dispatch('groupsurvey_setcurrent', { survey_id: resp.data.survey_id })
                  .then(() => {
                    this.$store.dispatch('groupsurveymembers_fetch', { survey_id: this.$store.state.currentsurvey_id })
                      .then((resp) => {
                        this.$store.dispatch('groupmembers_fetch', { group_id: this.$store.state.currentgroup_id })
                          .then((resp) => {
                            this.$router.push('/create/group/survey/details')
                          })
                      })
                  })
              })
          })
      }
      this.loading = false
    }
  }
}
</script>
<style scoped>
.td-rounded-left {
  border-radius: 6px;
  border-right: none;
}

.td-3 {
  width: 25%;
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
